import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AnalyticsProvider, PostHogPageviewTracker } from '@lightning/analytics';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AnalyticsProvider
        config={{
          app: 'howie',
          logEventUrl:
            import.meta.env.VITE_GCP_LOG_EVENT_URL ||
            'https://log-event-613409150384.us-east1.run.app/',
          posthogApiKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY || '',
          posthogHost:
            import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
          partner: import.meta.env.VITE_PARTNER || null,
          debug: import.meta.env.MODE === 'development',
        }}
      >
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <PostHogPageviewTracker />
            <App />
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  fontFamily: 'Roboto, sans-serif',
                },
              }}
            />
          </BrowserRouter>
        </QueryClientProvider>
      </AnalyticsProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
